export const addVChartProperty = (data, op) => {
    const context = op.beforeCall();
    return data.forEach(((d, i) => op.call(d, i, context))), context.keyMap && (context.keyMap.clear(), 
    context.keyMap = null), data;
};
//# sourceMappingURL=add-property.js.map
